const ITEMS = [
  "Lillet Spritz offert",
  "Ouverts et hors zone de couvre-feu",
  "Réservez votre table",
  "Toulouse · Ville rose",
];

export default function Marquee() {
  return (
    <div
      data-testid="offer-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-coal py-6"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((dup) => (
          <div
            key={dup}
            className="flex items-center"
            aria-hidden={dup === 1}
          >
            {ITEMS.map((item) => (
              <span key={item} className="flex items-center">
                <span className="font-display px-8 text-2xl italic text-champagne md:text-3xl">
                  {item}
                </span>
                <span className="inline-block h-2 w-2 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
